// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__pgMPK","newsletterWrapper":"styles_newsletterWrapper__6sS70","newsletter":"styles_newsletter__yv7l0","intro":"styles_intro__69IXc"};